import React, { createContext, useContext, useEffect, useState } from 'react';
import { getComingSoonStatus } from '../config';

const ComingSoonContext = createContext(null);

const DEFAULT_STATUS = {
  enabled: false,
  isDev: false,
  ip: '',
};

export function ComingSoonProvider({ children }) {
  const [status, setStatus] = useState(DEFAULT_STATUS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;

    (async () => {
      try {
        const data = await getComingSoonStatus();
        if (!active) return;
        setStatus({
          enabled: Boolean(data?.enabled),
          isDev: Boolean(data?.is_dev),
          ip: data?.ip || '',
        });
      } catch {
        if (active) setStatus(DEFAULT_STATUS);
      } finally {
        if (active) setLoading(false);
      }
    })();

    return () => {
      active = false;
    };
  }, []);

  return (
    <ComingSoonContext.Provider value={{ ...status, loading }}>
      {children}
    </ComingSoonContext.Provider>
  );
}

export function useComingSoon() {
  const ctx = useContext(ComingSoonContext);
  if (!ctx) {
    throw new Error('useComingSoon must be used inside ComingSoonProvider');
  }
  return ctx;
}
